import React from 'react';
import { Box } from '@mui/material';

import { Tooltip } from 'components/common/modals';
import { PRIORITIES } from '../SetPriority/SetPriority';

const EmailListItemPriority = ({ priority }) => {
  if (!priority) {
    return null;
  }
  const item = PRIORITIES.find((option) => option.value === priority);
  if (!item) {
    return null;
  }
  return (
    <Tooltip title={`${item.label} priority`}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>{item.icon}</Box>
    </Tooltip>
  );
};

export default EmailListItemPriority;
